import Preview from '../components/Preview'
import { connect } from 'react-redux'
import FileSaver from 'file-saver'
import {setParsedContext, setContextsFromGist} from '../util/actions'

const mapStateToProps = (state) => ({
  user: state.user,
  accessToken: state.user.accessToken,
  contents: state.mapping.contents,
  parsedContext: state.context.parsedContext,
  inputKeys: state.mapping.inputKeys,
  mapped: state.context.mapped,
  selectedContext: state.mapping.selectedContext,
  vocabularyType: state.mapping.vocabularyType,
  rawJsonld: {
    '@id': '',
    '@type': state.mapping.vocabularyType ? state.mapping.vocabularyType : '',
  },
  contextsFromGist: state.mapping.contextsFromGist
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  setParsedContext: (parsedContext) => {
    dispatch(setParsedContext(parsedContext))
  },
  downloadJsonLd: (props, jsonLd) => {
    if (typeof props.rawJsonld !== 'object') {
      window.alert('JSON-LD is not valid')
    } else {
      const blob = new Blob([jsonLd], {type: 'application/json'})
      FileSaver.saveAs(blob, 'data.json')
    }
  },
  downloadContext: (props, context) => {
    if (typeof props.parsedContext !== 'object') {
      window.alert('Context is not valid')
    } else {
      const blob = new Blob([context], {type: 'application/json'})
      FileSaver.saveAs(blob, 'context.json')
    }
  },
  updateContextListFromGist: (props, name, uri) => {
    const List = [{
      'name': name,
      'type': 'gist',
      'uri': uri,
      'checked': false
    }].concat(props.contextsFromGist)
    dispatch(setContextsFromGist(List))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(Preview)



// WEBPACK FOOTER //
// ./src/containers/Preview.js